import React from 'react';
import PropTypes from 'prop-types';
import { FieldTable } from '../../../components/FieldTable/FieldTable';
import { FieldTableColumnProps } from '../../../components/FieldTable/FieldTableTypes';
import { SitePayment } from '../../../generated/graphql';
import { CurrencySelect } from '../../../components/MaterialSelects/CurrencySelect';
import { calculateFixedRowValue, uniqueId } from '../../../utils';


const baseColumns: FieldTableColumnProps<SitePayment>[] = [
    {
        header: 'Currency',
        accessor: 'currency',
        sort: 'currency.label',
        dataType: 'select',
        width: 'full',
        options: {
            label: 'label',
            renderEditor: ({ field }) =>
                <CurrencySelect {...field} autoFocus={true} error={field.error} />,
        }
    },
    {
        header: 'Date',
        accessor: 'date',
        dataType: 'date',
        width: 'full',
        summaries: {
            // eslint-disable-next-line react/display-name
            header: () => <b style={{ display: 'flex', alignItems: 'center' }}>Net Rental Liability</b>
        }
    }
];
function newRow(): SitePayment {
    return { id: uniqueId() };
}

const SitePaymentPane = ({ values, setValue, readOnly, siteRental }) => {
    const siteRentalLiability = calculateFixedRowValue(siteRental);
    const columns: FieldTableColumnProps<SitePayment>[] = [...baseColumns,
    {
        header: 'Amount',
        accessor: 'amount',
        dataType: 'number',
        width: 'full',
        options: {
            renderViewer: ({ row }) => { return row?.amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
        },
        summaries: {
            header: ({ rows }) => {
                const paymentSum = rows.reduce((acc, row) => acc + row.amount, 0);
                const adjustedLiability = parseFloat((siteRentalLiability - paymentSum).toFixed(2));
                return adjustedLiability.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
            }
        }
    }
    ];
    return (
        <FieldTable columns={columns}
            name="sitePayments"
            values={values}
            className="site-health-and-safety"
            setValue={setValue}
            newRow={newRow}
            readOnly={readOnly}
            newRowLabel="Add Site Payment"
            summaries={{ header: (oldRow, newRow) => { return (!newRow ? 'header' : '') } }}
        />
    );
}

SitePaymentPane.propTypes = {
    payment: PropTypes.array
};

export default SitePaymentPane;

